import { render } from "./DemoManager.vue?vue&type=template&id=5ec14c74&scoped=true"
import script from "./DemoManager.vue?vue&type=script&lang=js"
export * from "./DemoManager.vue?vue&type=script&lang=js"

import "./DemoManager.vue?vue&type=style&index=0&id=5ec14c74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec14c74"]])

export default __exports__